@let widgetRef =
  currentRendering.subfeatures.slideout.selectors.widgetRef.asSignal();

@if (widgetRef) {
  @let info =
    currentRendering.subfeatures.widgets.selectors
      .getEntry(widgetRef)
      .asSignal();
  <atn-ds-slideout-overlay
    [hasBackdrop]="true"
    [name]="info?.rendering?.name ?? 'Details'"
    (backdropClicked)="
      closeSlideout('Mosaic.CurrentRendering.Slideout.Backdrop.Clicked')
    "
  >
    <i
      actions
      class="atn-icon atn-close atn-red"
      (click)="closeSlideout('Mosaic.CurrentRendering.Slideout.Close.Clicked')"
    ></i>

    <div class="atn-mosaic-slideout">
      <div class="atn-mosaic-slideout__body">
        <atn-mosaic-widget
          [refId]="widgetRef.id"
          [rendering]="info?.rendering"
          [loading]="info?.isLoading ?? true"
          [error]="info?.error?.message"
          renderMode="slideout"
        />
      </div>
      <div class="atn-mosaic-slideout__footer">
        <atn-ds-button
          type="transparent"
          (click)="
            closeSlideout(
              'Mosaic.CurrentRendering.Slideout.Footer.Buttons.Cancel.Clicked'
            )
          "
          >Cancel</atn-ds-button
        >
      </div>
    </div>
  </atn-ds-slideout-overlay>
}
